import iframeApi from "../../api/iframeApi"

export const urlCheck = async (referrer, isReq) => {
    let status;
    await iframeApi.get("/addReq", {
        params:{
            url: referrer,
            isReq
        }
    }).then(async (res) => {
        status = await res.data.err;
    })
    return status;
}

